export interface NavItem {
  label: string;
  path: string;
}

export const navigation: NavItem[] = [
  { label: "Home", path: "/" },
  { label: "Retreats", path: "/retreats" },
  { label: "Your Host", path: "/your-host" },
  { label: "Contact", path: "/contact" },
];
